import { Typography, useTheme } from "@mui/material";
import { Col, Row } from "v2/components/base/Flex/ui";
import { withAppSideBarNav } from "../../hocs/withAppSideBarNav";
import { useNavigationItem } from "../../hooks/useNavigationItem";

const AppNavWrapper = ({
  route,
  children,
  ...props
}: {
  route: string;
  children: React.ReactNode;
}) => {
  const theme = useTheme();
  const { isActive } = useNavigationItem(route);

  return (
    <Row
      type="cc"
      sx={{
        gap: "16px",
        color: isActive ? theme.palette.primary.main : theme.palette.text.secondary,
        "&:hover": { cursor: "pointer", color: theme.palette.primary.main },
      }}
      {...props}>
      {children}
    </Row>
  );
};

const AppNavItemNav = ({ label, ...props }: { label: string }) => {
  return (
    <Col type="cc" {...props}>
      <Typography variant="mobile-display-s">{label}</Typography>
    </Col>
  );
};

const AppNavItemIcon = ({ icon }: { icon: React.ReactNode }) => {
  return (
    <Col type="cc" sx={{ width: "24px", height: "24px" }}>
      {icon}
    </Col>
  );
};

const AppNavItem = {
  Wrapper: AppNavWrapper,
  Nav: withAppSideBarNav(AppNavItemNav),
  Icon: AppNavItemIcon,
};

export default AppNavItem;
